import clsx from 'clsx';
import { forwardRef } from 'react';

export const TableCell = forwardRef<HTMLTableCellElement, React.TdHTMLAttributes<HTMLTableCellElement>>(
    ({ className, ...props }, ref) => (
        <td ref={ref} className={clsx('px-4 py-2 min-h-tableCell align-middle relative', className)} {...props} />
    )
);
